<div cdkOverlayOrigin #trigger="cdkOverlayOrigin" (mouseenter)="open = true" [ngClass]="{ active: active} ">
    <a class="side-nav-item has-menu" [ngClass]="{'active':active}">
        <profile class="img-profile" [userImageUrl]="$safeNavigationMigration(state?.user?.image)" [userName]="$safeNavigationMigration(state?.user?.name)" [size]="16"></profile>
        <span class="title">{{state?.user?.firstName}} {{state?.user?.lastName}}</span>
    </a>
    <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="trigger" [cdkConnectedOverlayOpen]="open" [cdkConnectedOverlayPositions]="positions" [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayScrollStrategy]="overlay.scrollStrategies.close()" (attach)="onAttached()" (detach)="open = false" (overlayOutsideClick)="open = false">
        <div class="side-nav-item-menu" (mouseleave)="open = false">
            <div class="fieldset">
                <div class="actions actions-user" (mouseenter)="open = true">

                    <a class="user side-nav-item" [href]='accountUrl' target="_blank">
                        <i class="fa-solid fa-circle-user"></i>
                        <span>My Account</span>
                    </a>

                    <a class="user side-nav-item" routerLink="/user/notifications" (click)="open = false">
                        <i class="fa-solid fa-bell"></i>
                        <span>Notification Preferences</span>
                    </a>

                    <a class="user side-nav-item" routerLink="/user/security" (click)="open = false">
                        <i class="fa-solid fa-shield-check"></i>
                        <span>Security & Permissions</span>
                    </a>

                </div>
                <a class="user side-nav-item" (click)="logout.emit()">
                    <i class="fa fa-sign-out"></i>
                    <span class='title'>Log Off</span>
                </a>
            </div>

        </div>

    </ng-template>

    <div cdkOverlayContainer></div>
</div>
